import * as React from 'react';
import type { ChangeEventHandler } from 'react';
import { AssetMode } from "../../mediaLibrary/asset.interface";
import SelectAssetImageSrc from "../../mediaLibrary/selectAssetImageSrc";
import type { Position } from "./InlineImageNode";

type Props = Readonly<{
	assetId?: number,
	handleOnClick: Function,
	src: string,
	setSrc: Function,
	width: number,
	setWidth: Function,
	height: number,
	setHeight: Function,
	altText: string,
	setAltText: Function,
	classes: string,
	setClasses: Function,
	position: Position,
	handlePositionChange: ChangeEventHandler<HTMLSelectElement>,
	isDisabled: boolean,
	showModalOnRender?: boolean,
}>;

export default function InlineImageForm({
	handleOnClick,
	isDisabled,
	showModalOnRender = false,

	src,
	setSrc,

	width = 0,
	setWidth,

	height = 0,
	setHeight,

	altText,
	setAltText,

	classes = '',
	setClasses,

    position,
	handlePositionChange,
}: Props) {
	return <>
		<div className="p-8">
			<div className="mb-4">
				<SelectAssetImageSrc
					src={src}
					onChangeSrc={setSrc}
					imageWidth={width ? width : 0}
					imageHeight={height ? height : 0}
					previewWidth={480}
					previewHeight={360}
					mode={AssetMode.Full}
					allowClear={false}
					showModalOnRender={showModalOnRender}
				/>
			</div>

			<div className="formItem">
				<label htmlFor="width" className="!min-w-[140px]">Width</label>
				<input id="width" type="number" value={width ? width : ""} onChange={(e) => {
					setWidth(parseInt(e.target.value));
				}}/>
			</div>

			<div className="formItem">
				<label htmlFor="height" className="!min-w-[140px]">Height</label>
				<input id="height" type="number" value={height ? height : ""} onChange={(e) => {
					setHeight(parseInt(e.target.value));
				}}/>
			</div>

			<div className="formItem">
				<label htmlFor="alt" className="!min-w-[140px]">Alt text</label>
				<input id="alt" type="text" value={altText} data-test-id="image-modal-alt-text-input" onChange={(e) => {
					setAltText(e.target.value);
				}}/>
			</div>

			<div className="formItem">
				<label htmlFor="position-select" className="!min-w-[140px]">Position</label>
				<select
					name="position"
					id="position-select"
					value={position}
					onChange={handlePositionChange}>
					<option value="left">Left</option>
					<option value="right">Right</option>
					<option value="full">Full Width</option>
				</select>
			</div>

			<div className="formItem mb-0">
				<label htmlFor="classes" className="!min-w-[140px]">Css class</label>
				<input id="classes" type="text" value={classes} data-test-id="image-modal-classes-text-input" onChange={(e) => {
					setClasses(e.target.value);
				}}/>
			</div>
		</div>

		<div className="px-8 py-6 bg-grey-100 text-right">
			<button
				className="bg-white"
				data-test-id="image-modal-file-upload-btn"
				disabled={isDisabled}
				onClick={() => handleOnClick()}
			>
				Confirm
			</button>
		</div>
	</>
}
